import {dict_mixin} from "@/shared/mixins/dict_mixin";
import {api_mixin} from "@/shared/mixins/api_mixin";


export const turbo_pancake_store = {
    namespaced: true,
    state: () => ({
        data: {},
        rooms: [],

    }),
    mutations: {
        set_property(state, {dotted_path, value, copy = false}) {
            if (copy) {
                value = {...value}
            }
            dict_mixin.methods.deep_set(state, dotted_path, value)
        },
    },
    actions: {
        async load_data({state, dispatch, commit}, {resource=null}) {
            let mode = process.env.VUE_APP_DEV_MODE
            console.log(`Load data ${mode}`)
            if (mode === "LOCAL") {
                return await dispatch("load_local_data", {resource})

            } else if (mode === "REMOTE"){
                if (!process.env.VUE_APP_SITE_ID) {
                    console.error(`Invalid vue app site id ${process.env.VUE_APP_SITE_ID}`)
                    return
                }
                return await dispatch("load_remote_resource", {resource})
            } else {
                console.error(`Invalid vue app dev mode ${process.env.VUE_APP_DEV_MODE}`)
            }
        },
        async load_local_data({commit}) {
            let res = await fetch(`/data.json`)
            if (res.ok) {
                let data = await res.json()
                commit("set_property", {dotted_path: "site_settings", value: data})

            } else {
                console.error("Error fetching site settings from local")
            }
        },
        async load_remote_resource({commit}, {resource, toasted = null}) {
            let app_id = process.env.VUE_APP_SITE_ID
            let res = await api_mixin.methods.api_get_items({
                resource: resource,
                lookup: {
                    app: app_id
                },
                auth: false,
                turbo: true,
                return_data:true
            })
            if (res) {
                commit("set_property", {dotted_path: `data.${resource}`, value: res})
            } else {
                console.error(`Error fetching ${resource} from remote`)
            }
            return res
        },
        async change_mode({commit}, {resource, toasted = null}) {
            let app_id = process.env.VUE_APP_SITE_ID
            let res = await api_mixin.methods.api_get_items({
                resource: resource,
                lookup: {
                    app: app_id
                },
                auth: false,
            })
            if (res) {
                commit("set_property", {dotted_path: `data.${resource}`, value: res})
            } else {
                console.error(`Error fetching ${resource} from remote`)
            }
        }
    },
    getters: {
        site_settings(state) {
            return state.data
        }
    },
}
